import * as React from 'react';
import { SVGProps } from 'react';

const IconFileUnknownSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4a5 5 0 0 0-5 5v1H6V9a6 6 0 1 1 6 6v2h-1v-3h1a5 5 0 0 0 0-10Zm-1 17v-2h1v2h-1Z"
    />
  </svg>
);
export default IconFileUnknownSizeM;
